import React from 'react';
import { Button, Card, Form, Input, Layout, Space, Typography } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useI18n } from '../i18n';
import { brandSemantic } from '../config/brand';

const { Title, Text } = Typography;

export default function LoginPage({ handleLogin }) {
  const { t } = useI18n();

  return (
    <Layout style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', background: brandSemantic.layout }}>
      <Card style={{ width: 400, boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
        <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
          <img src="/PB-logo-mocca-web.png" alt="Logo" style={{ maxWidth: '200px' }} />
          <div>
            <Title level={2} style={{ marginBottom: '8px' }}>{t('SmartBoard CRM')}</Title>
            <Text type="secondary">{t('Welcome back! Please login to continue.')}</Text>
          </div>
        </Space>
        <Form onFinish={handleLogin} layout="vertical" style={{ marginTop: '24px' }}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: t('Please input your username!') }]}
          >
            <Input prefix={<UserOutlined />} placeholder={t('Username')} size="large" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: t('Please input your password!') }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder={t('Password')} size="large" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" size="large" block>
              {t('Login')}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Layout>
  );
}
